import { useSearchParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { useWindowSize } from "../../../../../../hook/useWindowSize";
import { useMySearchParams } from "../../../../../../hook/useMySearchParams";
import { general } from "../../../../../../store/action";
import { connect, useSelector } from "react-redux";
import PatientVisitCardsBox from "../../visit/dataList/patientVisitCardsBox";
import PatientVisitsTable from "../../visit/dataList/patientVisitsTable";
import { useGetVisits } from "../../../../../../hook/request/visit/visits";
import ShowPatientVisitModal from "../../visit/showPatientVisitModal";
import { TDataList } from "../../../../../../types/general";
import { useFindAccessInAccessList } from "../../../../../../constants/constant/accessProcess";
import DatePickerField from "../../../../general/form/datePickerField";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import visitDetail from "../../../../../pages/visits/visitDetail";
import { ISSUER_TYPE } from "../../../../../../constants/constant/enum";
import {
  JtoSimpleDateTime,
  mFormat,
  MtoJDateFormat,
  subtractJalaliDayFromGregorian,
} from "../../../../../../utils/date";
import moment from "moment";
import ShowPatientSakhadVisitModal from "../../visit/showPatientSakhadVisitModal";
const dataListTitles = [
  "نام پزشک",
  "تاریخ ویزیت",
  "نوع ویزیت",
  "وضعیت",
  "کدرهگیری",
  "",
];

const addSakhadVisitInterval = yup.object({
  fromDate: yup.string().required("این فیلد الزامیست."),
  // toDate: yup.string().required("این فیلد الزامیست."),
});

type TFilterValues = {
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
  fromDate?: string;
  // toDate?: string;
};

type patientVisitSummaryProps = {
  patientData?: any;
  openTab?: string;
  setOpenTab?: any;
};

type TAddSakhadVisitInterval = {
  fromDate: string;
  // toDate: string;
};

const PatientVisitSummary = ({
  patientData,
  openTab,
  setOpenTab,
}: patientVisitSummaryProps) => {
  const isProvider = useSelector(
    (state: any) => state.general.userDataReducer.isProvider,
  );
  const { findAccessInAccessList } = useFindAccessInAccessList();

  const [width] = useWindowSize();
  const [searchParams] = useSearchParams();
  const { getQueryParams } = useMySearchParams();
  const [visitsData, setVisitsData] = useState<TDataList>({
    data: [],
    count: 0,
  });
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    patient: patientData,
    pageNumber: "0",
    perPage: "10",
    search: "",
    fromDate: mFormat(), //subtractJalaliDayFromGregorian(),
    //MtoJDateFormat()
    // toDate: mFormat(),
  });

  const [fieldValue, setFieldValue] = useState<TAddSakhadVisitInterval>({
    fromDate: mFormat(), // subtractJalaliDayFromGregorian(), //MtoJDateFormat(),
    // toDate: mFormat(), //MtoJDateFormat(),
  });
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<TAddSakhadVisitInterval>({
    defaultValues: {
      fromDate: mFormat(), //subtractJalaliDayFromGregorian(),
      // toDate: mFormat(),
    }, //useMemo(() => fieldValue, [fieldValue]),
    resolver: yupResolver(addSakhadVisitInterval),
  });

  const [watchedFromDate] = watch(["fromDate"]);

  // services
  const getVisitsRequest = useGetVisits(
    getQueryParams(filterValues),
    openTab === "patientSummary" && filterValues?.patient !== "0",
  );

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      patient: patientData,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "3",
      search: searchParams.get("search") || "",
      fromDate: JtoSimpleDateTime(MtoJDateFormat(watchedFromDate)),
      // toDate: JtoSimpleDateTime(MtoJDateFormat(watchedToDate), true),
    };
    setFilterValues(_filterValues);
    // console.log("VISIT_07 fromDate:", watchedFromDate);
    // console.log("VISIT_07 toDate:", watchedToDate);
  }, [searchParams, patientData, watchedFromDate]);

  useEffect(() => {
    getVisitsRequest?.data?.data?.result &&
      setVisitsData(getVisitsRequest?.data?.data.result);
    // console.log("VISIT_05", getVisitsRequest?.data?.data?.result);
  }, [getVisitsRequest.data]);

  return (
    <>
      <div className="rounded">
        <section className=" d-flex flex-column align-items-center flex-md-row border-bottom">
          <div className="form-group ms-md-auto fw-bold mx-3 my-2">
            ویزیت ها
          </div>

          {
            /*visitsData?.data?.at(0)?.insurerStatus?.issuerType?.id ==
            ISSUER_TYPE.ESATA.value &&*/ <>
              {/* <span>از تاریخ</span>
              <div className="form-group m-2">
                <DatePickerField
                  name="fromDate"
                  placeholder="از تاریخ"
                  format="YYYY/MM/DD"
                  // minDate={getStartOfTodayAsString()}
                  control={control}
                  error={errors}
                />
              </div> */}

              <span>ماه استعلام را انتخاب کنید:</span>
              <div className="form-group m-2">
                <DatePickerField
                  name="fromDate"
                  onlyMonthPicker={true}
                  placeholder="انتخاب ماه"
                  format="YYYY/MM"
                  control={control}
                  error={errors}
                />
              </div>
            </>
          }

          {(isProvider || findAccessInAccessList("EHR_VISIT")) && (
            <a
              className="p-1 d-flex align-items-center btn btn-dark rounded rounded-3 mx-3 my-2"
              href="#visits"
              onClick={() => setOpenTab("visits")}
            >
              <span className="m-1">همه ویزیت ها</span>
            </a>
          )}
        </section>
        <section className="mx-3 my-2">
          <section className="table-cont table-responsive">
            {width < 900 ? (
              <PatientVisitCardsBox
                dataList={visitsData}
                dataListTitles={dataListTitles}
                isRequesting={getVisitsRequest.isPending}
              />
            ) : (
              <PatientVisitsTable
                dataList={visitsData}
                dataListTitles={dataListTitles}
                isRequesting={getVisitsRequest.isPending}
              />
            )}
          </section>
        </section>
      </div>
      {openTab === "patientSummary" && <ShowPatientVisitModal />}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PatientVisitSummary);
